// About Banner Hero
if (document.querySelector('#top_banner')) {
  import('./about-banner-hero.js');
}

// About Simple Banner Image (Simple Hero Section with Video)
if (document.querySelector('.simple-hero-section')) {
  import('./about-simple-banner-image.js');
}

// Announcement Banner (Collection Page Promo Blocks)
// Height is handled via CSS aspect-ratio classes (no JS needed)

// Capsule Collections
if (document.querySelector('.capsule-collection-products-container')) {
  import('./capsule-collection.js');
}

// Collection Toolbar Marcella Custom
if (document.querySelector('marcella-collection-toolbar')) {
  import('./marcella-collection-toolbar.js');
}

// Collection Skeleton — skeleton shown only during filter/sort updates
if (document.querySelector('collection-skeleton')) {
  import('./collection-skeleton.js');
}

// Complete The Look
if (document.querySelector('.related-product-list-container')) {
  import('./complete-the-look.js');
}

// Main Customers Account (Marcella Custom)
if (document.querySelector('.account-page-main-container')) {
  import('./customers-account.js');
}

// Fabrics
if (document.querySelector('.fabrics-hero-main-container, .fabrics-main-container')) {
  import('./fabrics.js');
}

// Homepage Featured Collections
if (document.querySelector('.collection-blocks-mtcn, .collection-slider-carousel')) {
  import('./home-featured-collections.js');
}

// Header Sidebar (Mobile Navigation)
if (document.querySelector('#sidebar-menu')) {
  import('./header-sidebar.js');
}

// Header Search
if (document.querySelector('#predictive-search-form')) {
  import('./header-search.js');
}

// Home Hero Banner V1 (Big Promo Videos)
if (document.querySelector('.bigpromo-video-element')) {
  import('./home-hero-banner-v1.js');
}

// Homepage Bottom Video (Four Pillars)
if (document.querySelector('.four-pillars-video-container')) {
  import('./homepage-bottom-video.js');
}

// PDP Our Mission
if (document.querySelector('#our-mission')) {
  import('./pdp-our-mission.js');
}

// Our Mission 2025
if (document.querySelector('.our-mission-v5')) {
  import('./our-mission-2025.js');
}

// Our Mission PDP 2025
if (document.querySelector('.pdp-mission-v5')) {
  import('./pdp-our-mission-2025.js');
}

// Payment Message Modal
if (document.querySelector('#paymentModal')) {
  import('./payment-message-modal.js');
}

// School Days - Announcement and Design That Matters
if (document.querySelector('.section-school-days-bar, #design-that-matters')) {
  import('./school-days.js');
}

// Testimonial Carousel
if (document.querySelector('.testimonials-updated')) {
  import('./testimonial-carousel.js');
}

// Custom Modal
if (document.querySelector('custom-modal')) {
  import('./custom-modal.js');
}

// Product Card Marcella
if (document.querySelector('product-card-marcella')) {
  import('./product-card-marcella.js');
}

// Main Search Marcella
if (document.querySelector('.marcella-custom-search')) {
  import('./main-search-marcella.js');
}

// Newsletter Bar — Klaviyo two-step form enhancement
if (document.querySelector('.newsletter-bar')) {
  import('./newsletter-bar.js');
}

// Preorder & Final Sale Message
if (document.querySelector('[data-preorder-wrapper], .text-with-info-block[data-preorder-enabled="true"]')) {
  import('./preorder-finalsale-message.js');
}

// Buy Buttons Preorder Line Item Properties
if (document.querySelector('input[id^="preorder-property-"]')) {
  import('./buy-buttons-preorder.js');
}

// Preorderly App Button Override — normalize "PREORDER NOW" to "ADD TO CART | PREORDER"
if (document.querySelector('buy-buttons')) {
  import('./preorderly-button-override.js');
}

// Header V2 Desktop
if (document.querySelector('header-v2')) {
  import('./header-v2.js');
}

// Header V2 Mobile Drawer
if (document.getElementById('header-v2-mobile-drawer')) {
  import('./header-v2-mobile-drawer.js');
}

// Cart Drawer Component - always load for cart functionality
import('../components/cart-drawer-component.js');

// Cart Note Toggle - load when cart drawer exists
if (document.querySelector('cart-drawer, #cart-drawer')) {
  import('../components/cart-note-toggle.js');
}

// Accessibility - always load
import('./accessibility.js');

// Tagalys recommendations (New Arrivals widget)
if (document.querySelector('tagalys-recommendations')) {
  import('./tagalys-recommendations.js');
}

// Highest Discount collection sort (custom, replaces the old Nosto sort)
if (document.querySelector('[data-discount-sort-option]')) {
  import('./discount-sort.js');
}
